import React, {useEffect, useState} from 'react';

import {useLocation, matchPath, useNavigate, useParams, Params} from 'react-router';

import {Anchor, Breadcrumbs as MantineBreadcrumbs} from '@mantine/core';
import {navigateToPathForReason} from '@/modules/navigation/navigation_module';

type BreadcrumbLink = {label: string; link: string; avoidLink?: boolean};

type RegisteredBreadcrumbs = {
    pattern: string;
    getBreadcrumbs: (params: Params) => Promise<BreadcrumbLink[]>;
}

const registeredBreadcrumbs: RegisteredBreadcrumbs[] = [];

export const registerBreadcrumbs = (pattern: RegisteredBreadcrumbs['pattern'], getBreadcrumbs: RegisteredBreadcrumbs['getBreadcrumbs']) => {
    registeredBreadcrumbs.push({pattern, getBreadcrumbs});
};

export const Breadcrumbs = () => {
    const [breadcrumbLinks, setBreadcrumbLinks] = useState<BreadcrumbLink[]>([]);
    const [supportsBreadcrumbs, setSupportsBreadcrumbs] = useState(false);

    const loc = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    useEffect(() => {
        const foundBreadcrumbs = registeredBreadcrumbs.find(b => matchPath(b.pattern, loc.pathname));
        if (!foundBreadcrumbs) {
            setBreadcrumbLinks([]);
            setSupportsBreadcrumbs(false);
            return;
        }

        setSupportsBreadcrumbs(true);

        (async () => {
            const links = await foundBreadcrumbs.getBreadcrumbs(params);
            setBreadcrumbLinks(links);
        })();
    }, [loc.pathname]);

    if (!supportsBreadcrumbs) {
        return <div style={{height: '20px'}}/>;
    }

    return (
        <MantineBreadcrumbs
            style={{
                borderBottom: '1px solid',
                paddingBottom: '10px',
                marginBottom: '20px',
            }}
        >
            {breadcrumbLinks.map((link, i) => (
                link.avoidLink ? (
                    <span
                        key={i}
                    >
                        {link.label}
                    </span>
                ) : (
                    <Anchor
                        key={i}
                        onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            navigateToPathForReason(navigate, 'navigate_to_dynamic_path_from_breadcrumbs', link.link);
                        }}
                    >
                        {link.label}
                    </Anchor>
                )
            ))}
        </MantineBreadcrumbs>
    );
};
